import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Behandlungsraum } from '../../heimtier-behandlungs-raeume/heimtier-behandlungsraum-dialog/heimtier-behandlungsraum-dialog.component';
import { HeimtierKalenderEintrag } from '../../kalender/heimtier-kalender-eintrag';

export class WartezimmerAuswahlResult {
    ok: boolean;
    confirmed: boolean;
    behandlungsraum_id: number;
}

@Component({
    selector: 'kiene-zu-wartezimmer-verschieben-dialog',
    templateUrl: './zu-wartezimmer-verschieben-dialog.component.html',
    styleUrls: ['./zu-wartezimmer-verschieben-dialog.component.scss'],
})
export class ZuWartezimmerVerschiebenDialogComponent implements OnInit {
    public behandlungsraum: Behandlungsraum;

    constructor(
        public dialogRef: MatDialogRef<ZuWartezimmerVerschiebenDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public kalenderEintrag: HeimtierKalenderEintrag,
    ) {}

    ngOnInit(): void {}

    public save(): void {
        const result = new WartezimmerAuswahlResult();
        result.ok = true;
        result.confirmed = true;
        if (this.behandlungsraum?.behandlungsraum_id) {
            result.behandlungsraum_id = this.behandlungsraum.behandlungsraum_id;
        }
        this.dialogRef.close(result);
    }

    public selectRaum(event: Behandlungsraum): void {
        this.behandlungsraum = event;
    }
}
